import { AppEffects } from './app.effects';
import { CheckoutEffects } from './checkout.effects';
import { OrderEffects } from './order.effects';
import { SupportEffects } from './support.effects';

export const Effects = [CheckoutEffects, AppEffects, OrderEffects, SupportEffects];
